import dayjs from "dayjs";

export const formatDate = (dateString) => {
  if (!dateString) return "";
  return dayjs(dateString).format("DD-MM-YYYY");
};

// Line quantity: M.O. lines carry a decimal quantity (e.g. 2.5 heures) - their whole-number
// quantity is only its rounded-up placeholder
export const formatLineQuantity = (line) => (line?.decimalQuantity != null
  ? String(Math.round(Number(line.decimalQuantity) * 100) / 100)
  : line?.quantity ?? 0);

export const formatDateTime = (dateString) => {
  if (!dateString) return "";
  return dayjs(dateString).format("DD-MM-YYYY HH:mm:ss");
};

export const formatAmount = (amount) => {
  if (amount == null) return "";
  const formattedAmount = Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}).replace(/,/g, " ");
  return (
    <>
      {formattedAmount}
      {" "}
      <span className="text-[10px]">DHs</span>
    </>
  );
};

export const formatAmountString = (amount) => {
  if (amount == null) return "";
  const formattedAmount = Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).replace(/,/g, " ");
  
  return `${formattedAmount} DHs`;
};

export const formatAmountForm = (amount) => {
  if (amount == null || amount === "") return "";
  
  let processedAmount = amount;
  if (typeof amount === "string") {
    processedAmount = amount.replace(",", ".");
  }
  const numericAmount = Number(processedAmount);
  const hasDecimals = numericAmount % 1 !== 0;
  const formattedAmount = numericAmount.toLocaleString("en-US", {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).replace(/,/g, " ");
  
  return formattedAmount;
};

export const formatAmountClient = (amount) => {
  if (amount == null) return "";
  
  const formattedAmount = Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).replace(/,/g, " ");
  
  return (
    <>
      {formattedAmount}
    </>
  );
};


export const formatNumber = (amount) => {
    if (amount == null) return "0";
    return Number(amount).toLocaleString("en-US", 
  ).replace(/,/g, " ");
  };

  export const formatNumberDigit = (amount) => {
    if (amount == null) return "0";
    return Number(amount).toLocaleString("en-US", 
      {minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      }
  ).replace(/,/g, " ");
  };
